import { useQuery } from '@apollo/client';

import { GET_COURSE_DETAIL_BY_OPENEDX_ID } from '../queries/courseById';

export const useCourseDetail = (openedxCourseId) => {
  const { data, loading, error } = useQuery(GET_COURSE_DETAIL_BY_OPENEDX_ID, {
    variables: { courseId: openedxCourseId },
    skip: !openedxCourseId,
  });

  return {
    course: data?.courses?.[0] || null,
    loading,
    error,
  };
};
